import MessageBanner from './MessageBanner'
import type { ReactNode, VFC } from 'react'
import { useEffect } from 'react'
import type { BannerProps, BannerAppearance } from '@panwds/react-ui'


interface IBannerProps {
  infoMessage: string,
  type: 'inline' | 'page',
  appearance: BannerAppearance,
  timerInMilliSec?: number,
  callback?: object,
  autoDismiss?: boolean,
  closable?: boolean,
  bannerActions?: ReactNode
}
const ActivationBanner: VFC<IBannerProps> = (props) => {
  const { timerInMilliSec = 15000, infoMessage, callback = {}, autoDismiss = false, closable = false, type, appearance, bannerActions: actions } = props
  const bannerProps: BannerProps = {
    appearance,
    type,
    dataMetrics: 'activation-banner',
    dataTestId: 'activation-banner',
    showIcon: true,
    actions
  }

  useEffect(() => {
    if (autoDismiss) {
      setTimeout(() => {
        if (typeof callback === 'function') {
          callback()
        }
      }, timerInMilliSec)
    }
  }, [callback, timerInMilliSec, autoDismiss])

  return (
    <div>
      {infoMessage && <MessageBanner message={infoMessage} doNotCloseBanner={!closable} bannerProps={bannerProps} />}
    </div>
  )
}

export default ActivationBanner
